import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject, Subscription, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { CustomHttpClientService } from "./custom-http-client.service";
@Injectable()
export class ioService {
  private _ioMessage$: Subject<{}>;
  private timer;
  private sub: Subscription;
  url = environment.apiUrl;
  token = localStorage.getItem("token");

  constructor(private http: CustomHttpClientService) {
    this.token = localStorage.getItem("token");
    this._ioMessage$ = <Subject<{}>>new Subject();
    //this.registerSailsListener();
  }

  get ioMessage$() {
    return this._ioMessage$.asObservable();
  }

  registerSailsListener(): void {
    //Get all users
    let id = localStorage.getItem("residents");

    self["io"].socket.post(
      "/message/index",
      {
        buildings: "all",
        buildingsFilter: false,
        page: "messages",
        extraHeaders: {
          authorization: this.token,
        },
      },
      function (body, response) {}
    );

    self["io"].socket.on("connected", (connected) => {
      this._ioMessage$.next(connected);
    });

    self["io"].socket.on("allusers", (users) => {
      this._ioMessage$.next(users);
    });

    self["io"].socket.on("getAllMsgCount", (totalMsg) => {
      this._ioMessage$.next(totalMsg);
    });

    self["io"].socket.on("message", (message) => {
      this._ioMessage$.next(message);
    });
  }

  checkUsers() {
    //self["io"].socket.get('/message/getAllMsgCount');
  }

  sendMessage(submission: {}) {
    self["io"].socket.get("/message/send", {
      message: submission["message"],
      extraHeaders: {
        authorization: this.token,
      },
    });
  }

  sendChatMessage(submission: {}) {
    self["io"].socket.get("/message/sendChat", {
      message: submission["message"],
      extraHeaders: {
        authorization: this.token,
      },
    });
  }
  sendChatMessageWithFile(submission: any): Observable<any> {
    const formData = new FormData();
    const messageContent = JSON.stringify(submission["message"]);
    formData.append("message", messageContent);
    formData.append("chatImage", submission["file"] || null);

    const headers = new HttpHeaders({
      Authorization: this.token,
    });

    return this.http
      .post<any>(`${this.url}message/sendChatFiles`, formData)
      .pipe(
        catchError((error) => {
          console.error("An error occurred:", error);
          return throwError(error);
        })
      );
  }

  joinPrivate(user) {
    self["io"].socket.post("/message/joinPrivate", {
      to: user.id,
      page: user.page,
      extraHeaders: {
        authorization: this.token,
      },
    });
  }

  leavePrivate(joinUserId) {
    self["io"].socket.get("/message/leavePrivate", {
      extraHeaders: {
        authorization: this.token,
      },
    });
    this._ioMessage$.next({
      message: "You are left Chat Room",
    });
  }

  joinGroup() {
    self["io"].socket.get("/message/joinGroup", {
      extraHeaders: {
        authorization: this.token,
      },
    });
    this._ioMessage$.next({
      message: "Joined Chat Room",
    });
  }

  leaveGroup() {
    self["io"].socket.get("/message/leaveGroup", {
      extraHeaders: {
        authorization: this.token,
      },
    });
    this._ioMessage$.next({
      message: "Left Chat Room",
    });
  }

  updateMsgStatus(roomId) {
    self["io"].socket.post("/message/updateMsgStatus", {
      roomId: roomId,
      extraHeaders: { authorization: this.token },
    });
  }
}
